import { useEffect, useRef } from 'react';
import { useWebSocket } from './useWebSocket';
import { useSessionStore } from '../store/sessionStore';

const FRAME_INTERVAL = 100;

export const useSignRecognition = (captureFrame: () => string | null) => {
  const { sendFrame } = useWebSocket();
  const { isRecording } = useSessionStore();
  const intervalRef = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    if (!isRecording) return;

    intervalRef.current = setInterval(() => {
      const frameData = captureFrame();
      if (frameData) sendFrame(frameData);
    }, FRAME_INTERVAL);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isRecording, captureFrame, sendFrame]);
};
